const { setCSRFToken } = require("coremh/components/utils");
const productTile = require("coremh/product/producttile");

export default function () {
    $(document).on("click", ".producttile-add-to-cart", async function (e) {
        e.preventDefault();

        const $this = $(this);
        const addToCartUrl = $this.data("url");
        const pid = $this.data("pid");
        const productDetailURL = await productTile.getRedirectionUrl($this.data("pdp-url"), pid);
        const isEnabledProductTileButtons = $this.data("is-enabled-producttile-buttons");
        var form = {
            pid: pid,
            pidsObj: "",
            childProducts: "",
            quantity: 1,
            isProductTile: true,
            csrf_token: ""
        };

        if (isEnabledProductTileButtons) {
            var isForcedOutOfStock = $this.data("is-forced-out-of-stock");
            var isRedirectUrl = $this.data("is-redirect-url");

            if (isForcedOutOfStock || isRedirectUrl) {
                window.location.href = productDetailURL;
                return;
            }

            if ($this.find(".add-to-cart-btn").length) {
                $.spinner().start();
            }
        }

        setCSRFToken().then(function(dataToken) {
            form.csrf_token = dataToken.csrf.token;
            makeAddToCartAjaxCall(addToCartUrl, form, productDetailURL);
        });
    });

    $(document).on("mouseover", ".js-img-container", function() {
        const $hoverImg = $(this).find(".js-hover-img");

        if ($hoverImg.length > 0 && !$hoverImg.hasClass("lazyloaded")) {
            $hoverImg.attr("src", $hoverImg.data("src")).addClass("lazyloaded");
        }
    });

    $(".product-grid>div").each(function() {
        if ($(this).find(".add-to-card-cta").hasClass("grayedout")) {
            $(this).addClass("grayed");
        }
    });

    productTile.setBadgeColors();
}

/**
 * Makes Ajax call for adding the product to Cart
 * @param {String} addToCartUrl
 * @param {Object} form
 * @param {String} productDetailURL
 */
function makeAddToCartAjaxCall(addToCartUrl, form, productDetailURL) {
    $.ajax({
        url: addToCartUrl,
        method: "POST",
        data: form,
        success: function (data) {
            var orderCapLimited = data.orderCapLimited || false;

            if (data && data.error && !orderCapLimited) {
                $.spinner().stop();
                window.location.href = productDetailURL;
            } else {
                $("body").trigger("product:afterAddToCart", data);
                handlePostCartAdd(data);
                $.spinner().stop();
                productTile.miniCartReportingUrl(data.reportingURL);
            }
        },
        error: function () {
            window.location.href = productDetailURL;
            return;
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {Object} response - ajax response from clicking the add to cart button
 */
var timer;
function handlePostCartAdd(response) {
    const $minicart = $(".minicart");
    const $header = $(".page-header");
    const $minicartPopover = $header.find(".minicart-popover");
    const messageType = response.error ? "alert-danger" : "alert-success";

    clearTimeout(timer);
    $minicart.trigger("count:update", response);

    // show minicart
    $minicart.find(".minicart-total").click();
    var $addToCartMsg = $(".add-to-cart-messages");

    if ($addToCartMsg.length === 0) {
        $("body").append(
            "<div class=\"add-to-cart-messages\"></div>"
        );
    }

    $(".add-to-cart-messages")
        .empty()
        .append(
            "<div class=\"alert " + messageType + " add-to-basket-alert text-center\" role=\"alert\">"
            + response.message
            + "</div>"
        );

    var observer = new MutationObserver(function () {
        if (response && response.error) {
            $minicartPopover.find(".minicart-error-message").empty().append(response.message);
            $minicartPopover.find(".minicart-error").removeClass("d-none");
        }
    });

    observer.observe($minicartPopover[0], {childList: true});

    timer = setTimeout(function () {
        $minicartPopover.find(".minicart-close-button").click();
        $minicartPopover.find(".minicart-error-message").empty();
        observer.disconnect();
    }, 5000);
}
